import { render, staticRenderFns } from "./BoxImagePreviewWidget.vue?vue&type=template&id=f317c1ca&scoped=true&"
import script from "./BoxImagePreviewWidget.vue?vue&type=script&lang=js&"
export * from "./BoxImagePreviewWidget.vue?vue&type=script&lang=js&"
import style0 from "./BoxImagePreviewWidget.vue?vue&type=style&index=0&id=f317c1ca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f317c1ca",
  null
  
)

export default component.exports